/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {makeStyles} from "@material-ui/core/styles";
import {GET_CONTACT_LISTS} from "../database/queries/contactListQueries"; //optional, for more compact styles
import 'react-awesome-query-builder/css/styles.scss';
import 'react-awesome-query-builder/css/compact_styles.scss';
import {useQuery} from "@apollo/react-hooks";
import Moment from "react-moment";
import CalendarStrings from "../constants/calendarStrings";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../constants/tableIcons";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    dlog: {
        // zIndex: '1000 !important',
        '& .MuiDialog-paper': {
            width: 600,
        },
    }
}));

const columns = [
    {
        title: 'Name',
        width: '30%',
        field: 'contactListName',
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
    {
        title: 'Description',
        width: '35%',
        field: 'contactListDescription',
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
    {
        title: 'Members',
        width: '55%',
        field: 'memberCount',
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
    {
        title: 'Last Updated',
        width: '20%',
        render: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
];

const SelectContactListsDialog = props => {
    const classes = useStyles();
    const [contactLists, setContactLists] = useState();
    const [selectedRows, setSelectedRows] = useState([]);

    const {data: getContactListsData, refetch: getContactListsRefetch} = useQuery(GET_CONTACT_LISTS, {
        skip: !props.open,
        variables: {
            // contactListType: props.contactListType,
            orderList: ['contactListName ASC']
        },
    });

    useEffect(() => {
        if (props.open) {
            getContactListsRefetch();
        }
    }, [props.open]);

    useEffect(() => {
        if (getContactListsData && getContactListsData.contactLists) {
            setSelectedRows([]);
            let tmpContactLists = [...getContactListsData.contactLists];
            if (props.hideContactListIds) tmpContactLists = tmpContactLists.filter((el) => !(props.hideContactListIds.includes(el)));
            setContactLists(tmpContactLists);
        }
    }, [getContactListsData]);

    return (
        <div>
            <Dialog className={classes.dlog} open={props.open} onClose={props.handleCancel}
                    aria-labelledby="form-dialog-title">
                <div>
                    <AppBar position="static" color={props.color ? props.color : 'default'} className={classes.toolbar}>
                        <Toolbar variant="dense" className={classes.toolbar}>
                            <Typography variant="subtitle1" color="inherit" m={2} style={{marginRight: 20}}>
                                {props.title}
                            </Typography>
                            {props.showLoading && <CircularProgress color="inherit" size={24}/>}
                            <div className={classes.grow}/>
                            {props.children}
                        </Toolbar>
                    </AppBar>
                </div>
                <DialogContent>
                    <div className={classes.root}>
                        {contactLists && (
                            <SizeMe>
                                {({size}) => {
                                    let height = size.height;
                                    if (!height) height = window.innerHeight;

                                    const tableOptions = {
                                        actionsColumnIndex: -1,
                                        header: true,
                                        // maxBodyHeight: height -100,
                                        padding: 'dense',
                                        paging: false,
                                        selection: true,
                                        selectionProps: r => ({
                                            name: r.contactListName.replace(/\s+/g, '-').toLowerCase() === '___test' ? 'checkTest' : ''
                                        }),
                                        toolbar: false,
                                    };

                                    return (<MaterialTable
                                        columns={columns}
                                        data={contactLists}
                                        icons={tableIcons}
                                        options={tableOptions}
                                        title='Contact Lists'
                                        onSelectionChange={(rows) => {
                                            setSelectedRows(rows);
                                        }}
                                    />);
                                }}
                            </SizeMe>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        id={"contact-list-cancel"}
                        onClick={() => {
                            setSelectedRows([]);
                            props.handleCancel()
                        }}
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        id={"contactList-apply"}
                        disabled={selectedRows.length === 0}
                        onClick={() => {
                            props.handleSelect(selectedRows);
                        }}
                        color="primary"
                    >
                        Select
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default SelectContactListsDialog
